import type { IFiatIcon } from './helpers';

export const FiatIcon = ({ currencyCode, variant = 'round', ...rest }: IFiatIcon) => {
	if (variant === 'round') {
		if (currencyCode === 'USD')
			return (
				<svg
					width='14'
					height='14'
					viewBox='0 0 14 14'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
					{...rest}
				>
					<g clipPath='url(#clip0_14451_270316)'>
						<rect
							width='14'
							height='14'
							rx='7'
							fill='white'
						/>
						<rect
							x='-3'
							width='20'
							height='14'
							rx='2'
							fill='white'
						/>
						<mask
							id='mask0_14451_270316'
							style={{ maskType: 'luminance' }}
							maskUnits='userSpaceOnUse'
							x='-3'
							y='0'
							width='20'
							height='14'
						>
							<rect
								x='-3'
								width='20'
								height='14'
								rx='2'
								fill='white'
							/>
						</mask>
						<g mask='url(#mask0_14451_270316)'>
							<path
								d='M17 14H-3V13.0664H17V14ZM17 12.1338H-3V11.2002H17V12.1338ZM17 10.2666H-3V9.33301H17V10.2666ZM17 8.40039H-3V7.4668H17V8.40039ZM17 6.5332H-3V5.59961H17V6.5332ZM17 4.66699H-3V3.7334H17V4.66699ZM17 2.7998H-3V1.86621H17V2.7998ZM17 0.933594H-3V0H17V0.933594Z'
								fill='#D02F44'
							/>
							<rect
								x='-3'
								width='8.57143'
								height='6.53333'
								fill='#46467F'
							/>
							<g filter='url(#filter0_d_14451_270316)'>
								<path
									d='M-1.57104 4.66699C-1.30822 4.66719 -1.09546 4.87618 -1.09546 5.13379C-1.09557 5.39131 -1.30829 5.60039 -1.57104 5.60059C-1.83397 5.60059 -2.0475 5.39143 -2.04761 5.13379C-2.04761 4.87606 -1.83404 4.66699 -1.57104 4.66699ZM0.333252 4.66699C0.596245 4.66699 0.809814 4.87606 0.809814 5.13379C0.809707 5.39143 0.596178 5.60059 0.333252 5.60059C0.0703683 5.60054 -0.143203 5.3914 -0.143311 5.13379C-0.143311 4.87609 0.070302 4.66704 0.333252 4.66699ZM2.23853 4.66699C2.50133 4.66721 2.71411 4.87619 2.71411 5.13379C2.714 5.3913 2.50126 5.60036 2.23853 5.60059C1.9756 5.60059 1.76207 5.39143 1.76196 5.13379C1.76196 4.87606 1.97553 4.66699 2.23853 4.66699ZM4.14282 4.66699C4.40582 4.66699 4.61938 4.87606 4.61938 5.13379C4.61928 5.39143 4.40575 5.60059 4.14282 5.60059C3.87992 5.60056 3.66637 5.39142 3.66626 5.13379C3.66626 4.87607 3.87985 4.66702 4.14282 4.66699ZM-0.618896 3.7334C-0.35599 3.73347 -0.143346 3.94254 -0.143311 4.2002C-0.143311 4.45788 -0.355968 4.66692 -0.618896 4.66699C-0.881889 4.66699 -1.09546 4.45793 -1.09546 4.2002C-1.09542 3.94249 -0.881867 3.7334 -0.618896 3.7334ZM1.2854 3.7334C1.54837 3.7334 1.76193 3.94249 1.76196 4.2002C1.76196 4.45793 1.54839 4.66699 1.2854 4.66699C1.02256 4.66682 0.809814 4.45782 0.809814 4.2002C0.80985 3.9426 1.02258 3.73357 1.2854 3.7334ZM3.19067 3.7334C3.45356 3.7335 3.66622 3.94255 3.66626 4.2002C3.66626 4.45787 3.45358 4.66689 3.19067 4.66699C2.92768 4.66699 2.71411 4.45793 2.71411 4.2002C2.71415 3.94249 2.9277 3.7334 3.19067 3.7334ZM-1.57104 2.7998C-1.30833 2.8 -1.09564 3.00914 -1.09546 3.2666C-1.09546 3.52421 -1.30822 3.7332 -1.57104 3.7334C-1.83404 3.7334 -2.04761 3.52433 -2.04761 3.2666C-2.04743 3.00902 -1.83393 2.7998 -1.57104 2.7998ZM0.333252 2.7998C0.596134 2.7998 0.809635 3.00902 0.809814 3.2666C0.809814 3.52433 0.596245 3.7334 0.333252 3.7334C0.070302 3.73335 -0.143311 3.5243 -0.143311 3.2666C-0.143131 3.00905 0.0704126 2.79985 0.333252 2.7998ZM2.23853 2.7998C2.50122 2.80003 2.71393 3.00916 2.71411 3.2666C2.71411 3.5242 2.50133 3.73318 2.23853 3.7334C1.97553 3.7334 1.76196 3.52433 1.76196 3.2666C1.76214 3.00902 1.97564 2.7998 2.23853 2.7998ZM4.14282 2.7998C4.4057 2.7998 4.61921 3.00902 4.61938 3.2666C4.61938 3.52433 4.40582 3.7334 4.14282 3.7334C3.87985 3.73337 3.66626 3.52432 3.66626 3.2666C3.66644 3.00903 3.87996 2.79983 4.14282 2.7998ZM-0.618896 1.86719C-0.355968 1.86726 -0.143311 2.0763 -0.143311 2.33398C-0.143526 2.59149 -0.356101 2.79973 -0.618896 2.7998C-0.881756 2.7998 -1.09524 2.59154 -1.09546 2.33398C-1.09546 2.07625 -0.881889 1.86719 -0.618896 1.86719ZM1.2854 1.86719C1.54839 1.86719 1.76196 2.07625 1.76196 2.33398C1.76175 2.59154 1.54826 2.7998 1.2854 2.7998C1.02269 2.79963 0.81003 2.59143 0.809814 2.33398C0.809814 2.07636 1.02256 1.86736 1.2854 1.86719ZM3.19067 1.86719C3.45358 1.86729 3.66626 2.07631 3.66626 2.33398C3.66604 2.59148 3.45345 2.79971 3.19067 2.7998C2.92781 2.7998 2.71433 2.59154 2.71411 2.33398C2.71411 2.07625 2.92768 1.86719 3.19067 1.86719ZM-1.57104 0.933594C-1.30822 0.933791 -1.09546 1.14278 -1.09546 1.40039C-1.09553 1.65794 -1.30827 1.86699 -1.57104 1.86719C-1.83399 1.86719 -2.04754 1.65806 -2.04761 1.40039C-2.04761 1.14266 -1.83404 0.933594 -1.57104 0.933594ZM0.333252 0.933594C0.596245 0.933594 0.809814 1.14266 0.809814 1.40039C0.809743 1.65806 0.5962 1.86719 0.333252 1.86719C0.0703461 1.86714 -0.143239 1.65803 -0.143311 1.40039C-0.143311 1.14269 0.070302 0.933643 0.333252 0.933594ZM2.23853 0.933594C2.50133 0.933815 2.71411 1.14279 2.71411 1.40039C2.71404 1.65793 2.50128 1.86697 2.23853 1.86719C1.97558 1.86719 1.76203 1.65806 1.76196 1.40039C1.76196 1.14266 1.97553 0.933594 2.23853 0.933594ZM4.14282 0.933594C4.40582 0.933594 4.61938 1.14266 4.61938 1.40039C4.61931 1.65806 4.40577 1.86719 4.14282 1.86719C3.87989 1.86716 3.66633 1.65805 3.66626 1.40039C3.66626 1.14267 3.87985 0.933618 4.14282 0.933594Z'
									fill='url(#paint0_linear_14451_270316)'
								/>
							</g>
						</g>
					</g>
					<defs>
						<filter
							id='filter0_d_14451_270316'
							x='-2.04761'
							y='0.933594'
							width='6.66699'
							height='5.66797'
							filterUnits='userSpaceOnUse'
							colorInterpolationFilters='sRGB'
						>
							<feFlood
								floodOpacity='0'
								result='BackgroundImageFix'
							/>
							<feColorMatrix
								in='SourceAlpha'
								type='matrix'
								values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
								result='hardAlpha'
							/>
							<feOffset dy='1' />
							<feColorMatrix
								type='matrix'
								values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
							/>
							<feBlend
								mode='normal'
								in2='BackgroundImageFix'
								result='effect1_dropShadow_14451_270316'
							/>
							<feBlend
								mode='normal'
								in='SourceGraphic'
								in2='effect1_dropShadow_14451_270316'
								result='shape'
							/>
						</filter>
						<linearGradient
							id='paint0_linear_14451_270316'
							x1='-2.04761'
							y1='0.933594'
							x2='-2.04761'
							y2='5.60059'
							gradientUnits='userSpaceOnUse'
						>
							<stop stopColor='white' />
							<stop
								offset='1'
								stopColor='#F0F0F0'
							/>
						</linearGradient>
						<clipPath id='clip0_14451_270316'>
							<rect
								width='14'
								height='14'
								rx='7'
								fill='white'
							/>
						</clipPath>
					</defs>
				</svg>
			);

		if (currencyCode === 'GHS')
			return (
				<svg
					width='14'
					height='14'
					viewBox='0 0 14 14'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
					{...rest}
				>
					<g clipPath='url(#clip0_6148_246538)'>
						<path
							d='M0 0H14V14H0V0Z'
							fill='#006B3F'
						/>
						<path
							d='M0 0H14V9.33333H0V0Z'
							fill='#FCD116'
						/>
						<path
							d='M0 0H14V4.66667H0V0Z'
							fill='#CE1126'
						/>
						<path
							d='M6.99997 4.66602L8.13747 9.33268L5.16028 6.4481H8.83747L5.86247 9.33268L6.99997 4.66602Z'
							fill='black'
						/>
					</g>
					<defs>
						<clipPath id='clip0_6148_246538'>
							<rect
								width='14'
								height='14'
								rx='7'
								fill='white'
							/>
						</clipPath>
					</defs>
				</svg>
			);

		return (
			<svg
				width='14'
				height='14'
				viewBox='0 0 14 14'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g clipPath='url(#clip0_6148_246475)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0H14V14H0V0Z'
						fill='white'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M9.33187 0H14V14H9.33187V0ZM0 0H4.66594V14H0V0Z'
						fill='#008753'
					/>
				</g>
				<defs>
					<clipPath id='clip0_6148_246475'>
						<rect
							width='14'
							height='14'
							rx='7'
							fill='white'
						/>
					</clipPath>
				</defs>
			</svg>
		);
	}

	if (variant === 'input') {
		if (currencyCode === 'GHS')
			return (
				<svg
					width='22'
					height='16'
					viewBox='0 0 22 16'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
					{...rest}
				>
					<g clipPath='url(#clip0_19874_98810)'>
						<path
							d='M0 0H21.3333V16H0V0Z'
							fill='#006B3F'
						/>
						<path
							d='M0 0H21.3333V10.6667H0V0Z'
							fill='#FCD116'
						/>
						<path
							d='M0 0H21.3333V5.33333H0V0Z'
							fill='#CE1126'
						/>
						<path
							d='M10.6666 5.33301L12.3999 10.6663L7.86328 7.36967H13.4666L8.93328 10.6663L10.6666 5.33301Z'
							fill='black'
						/>
					</g>
					<defs>
						<clipPath id='clip0_19874_98810'>
							<rect
								width='21.3333'
								height='16'
								fill='white'
							/>
						</clipPath>
					</defs>
				</svg>
			);

		if (currencyCode === 'NGN')
			return (
				<svg
					width='22'
					height='16'
					viewBox='0 0 22 16'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
					{...rest}
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0H21.3333V16H0V0Z'
						fill='white'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M14.22 0H21.3333V16H14.22V0ZM0 0H7.11V16H0V0Z'
						fill='#008753'
					/>
				</svg>
			);

		return (
			<svg
				width='21'
				height='16'
				viewBox='0 0 21 16'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					width='21'
					height='16'
					fill='white'
				/>
				<mask
					id='mask0_19874_98862'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='21'
					height='16'
				>
					<rect
						width='21'
						height='16'
						rx='2.33333'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask0_19874_98862)'>
					<path
						d='M21 16H0V14.9336H21V16ZM21 13.8662H0V12.7998H21V13.8662ZM21 11.7334H0V10.667H21V11.7334ZM21 9.59961H0V8.5332H21V9.59961ZM21 7.4668H0V6.40039H21V7.4668ZM21 5.33301H0V4.2666H21V5.33301ZM21 3.2002H0V2.13379H21V3.2002ZM21 1.06641H0V0H21V1.06641Z'
						fill='#D02F44'
					/>
					<rect
						width='9'
						height='7.46667'
						fill='#46467F'
					/>
					<g filter='url(#filter0_d_19874_98862)'>
						<path
							d='M1.5 5.33301C1.77608 5.33301 1.9999 5.57175 2 5.86621C2 6.16076 1.77614 6.39941 1.5 6.39941C1.22386 6.39941 1 6.16076 1 5.86621C1.0001 5.57175 1.22392 5.33301 1.5 5.33301ZM3.5 5.33301C3.77608 5.33301 3.9999 5.57175 4 5.86621C4 6.16076 3.77614 6.39941 3.5 6.39941C3.22386 6.39941 3 6.16076 3 5.86621C3.0001 5.57175 3.22392 5.33301 3.5 5.33301ZM5.5 5.33301C5.77608 5.33301 5.9999 5.57175 6 5.86621C6 6.16076 5.77614 6.39941 5.5 6.39941C5.22386 6.39941 5 6.16076 5 5.86621C5.0001 5.57175 5.22392 5.33301 5.5 5.33301ZM7.5 5.33301C7.77608 5.33301 7.9999 5.57175 8 5.86621C8 6.16076 7.77614 6.39941 7.5 6.39941C7.22386 6.39941 7 6.16076 7 5.86621C7.0001 5.57175 7.22392 5.33301 7.5 5.33301ZM2.5 4.2666C2.77614 4.2666 3 4.50525 3 4.7998C2.99997 5.09433 2.77612 5.33301 2.5 5.33301C2.22388 5.33301 2.00003 5.09433 2 4.7998C2 4.50525 2.22386 4.2666 2.5 4.2666ZM4.5 4.2666C4.77614 4.2666 5 4.50525 5 4.7998C4.99997 5.09433 4.77612 5.33301 4.5 5.33301C4.22388 5.33301 4.00003 5.09433 4 4.7998C4 4.50525 4.22386 4.2666 4.5 4.2666ZM6.5 4.2666C6.77614 4.2666 7 4.50525 7 4.7998C6.99997 5.09433 6.77612 5.33301 6.5 5.33301C6.22388 5.33301 6.00003 5.09433 6 4.7998C6 4.50525 6.22386 4.2666 6.5 4.2666ZM1.5 3.2002C1.77614 3.2002 2 3.43885 2 3.7334C1.99984 4.0278 1.77604 4.2666 1.5 4.2666C1.22396 4.2666 1.00016 4.0278 1 3.7334C1 3.43885 1.22386 3.2002 1.5 3.2002ZM3.5 3.2002C3.77614 3.2002 4 3.43885 4 3.7334C3.99984 4.0278 3.77604 4.2666 3.5 4.2666C3.22396 4.2666 3.00016 4.0278 3 3.7334C3 3.43885 3.22386 3.2002 3.5 3.2002ZM5.5 3.2002C5.77614 3.2002 6 3.43885 6 3.7334C5.99984 4.0278 5.77604 4.2666 5.5 4.2666C5.22396 4.2666 5.00016 4.0278 5 3.7334C5 3.43885 5.22386 3.2002 5.5 3.2002ZM7.5 3.2002C7.77614 3.2002 8 3.43885 8 3.7334C7.99984 4.0278 7.77604 4.2666 7.5 4.2666C7.22396 4.2666 7.00016 4.0278 7 3.7334C7 3.43885 7.22386 3.2002 7.5 3.2002ZM2.5 2.13281C2.77602 2.13281 2.9998 2.37164 3 2.66602C3 2.96057 2.77614 3.2002 2.5 3.2002C2.22386 3.2002 2 2.96057 2 2.66602C2.0002 2.37164 2.22398 2.13281 2.5 2.13281ZM4.5 2.13281C4.77602 2.13281 4.9998 2.37164 5 2.66602C5 2.96057 4.77614 3.2002 4.5 3.2002C4.22386 3.2002 4 2.96057 4 2.66602C4.0002 2.37164 4.22398 2.13281 4.5 2.13281ZM6.5 2.13281C6.77602 2.13281 6.9998 2.37164 7 2.66602C7 2.96057 6.77614 3.2002 6.5 3.2002C6.22386 3.2002 6 2.96057 6 2.66602C6.0002 2.37164 6.22398 2.13281 6.5 2.13281ZM1.5 1.06641C1.7761 1.06641 1.99993 1.30512 2 1.59961C2 1.89416 1.77614 2.13281 1.5 2.13281C1.22386 2.13281 1 1.89416 1 1.59961C1.00007 1.30512 1.2239 1.06641 1.5 1.06641ZM3.5 1.06641C3.7761 1.06641 3.99993 1.30512 4 1.59961C4 1.89416 3.77614 2.13281 3.5 2.13281C3.22386 2.13281 3 1.89416 3 1.59961C3.00007 1.30512 3.2239 1.06641 3.5 1.06641ZM5.5 1.06641C5.7761 1.06641 5.99993 1.30512 6 1.59961C6 1.89416 5.77614 2.13281 5.5 2.13281C5.22386 2.13281 5 1.89416 5 1.59961C5.00007 1.30512 5.2239 1.06641 5.5 1.06641ZM7.5 1.06641C7.7761 1.06641 7.99993 1.30512 8 1.59961C8 1.89416 7.77614 2.13281 7.5 2.13281C7.22386 2.13281 7 1.89416 7 1.59961C7.00007 1.30512 7.2239 1.06641 7.5 1.06641Z'
							fill='url(#paint0_linear_19874_98862)'
						/>
					</g>
				</g>
				<defs>
					<filter
						id='filter0_d_19874_98862'
						x='1'
						y='1.06641'
						width='7'
						height='6.49967'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='1.16667' />
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_19874_98862'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_19874_98862'
							result='shape'
						/>
					</filter>
					<linearGradient
						id='paint0_linear_19874_98862'
						x1='1'
						y1='1.06641'
						x2='1'
						y2='6.39941'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='white' />
						<stop
							offset='1'
							stopColor='#F0F0F0'
						/>
					</linearGradient>
				</defs>
			</svg>
		);
	}

	if (currencyCode === 'GHS')
		return (
			<svg
				width='22'
				height='16'
				viewBox='0 0 22 16'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					width='22'
					height='16'
					rx='2'
					fill='white'
				/>
				<mask
					id='mask0_2255_75847'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='22'
					height='16'
				>
					<rect
						width='22'
						height='16'
						rx='2'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask0_2255_75847)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 5.33333H22V0H0V5.33333Z'
						fill='#E71F37'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 16.0001H22V10.6667H0V16.0001Z'
						fill='#118B56'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 10.6666H22V5.33325H0V10.6666Z'
						fill='#FDD64C'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M11 9.28945L9.46059 10.4241L10.0448 8.58279L8.50917 7.44272L10.4096 7.43939L11 5.6001L11.5904 7.43939L13.4909 7.44272L11.9553 8.58279L12.5395 10.4241L11 9.28945Z'
						fill='#262626'
					/>
				</g>
			</svg>
		);

	if (currencyCode === 'NGN')
		return (
			<svg
				width='28'
				height='21'
				viewBox='0 0 28 21'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='1.13888'
					y='0.606283'
					width='25.7223'
					height='19.0843'
					rx='2.90413'
					fill='white'
					stroke='#F5F5F5'
					strokeWidth='0.829753'
				/>
				<mask
					id='mask0_11020_161705'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='28'
					height='21'
				>
					<rect
						x='1.13888'
						y='0.606283'
						width='25.7223'
						height='19.0843'
						rx='2.90413'
						fill='white'
						stroke='white'
						strokeWidth='0.829753'
					/>
				</mask>
				<g mask='url(#mask0_11020_161705)'>
					<rect
						x='18.4253'
						y='0.191406'
						width='8.85069'
						height='19.9141'
						fill='#189B62'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0.723999 20.1055H9.57469V0.191406H0.723999V20.1055Z'
						fill='#189B62'
					/>
				</g>
			</svg>
		);

	return (
		<svg
			width='22'
			height='16'
			viewBox='0 0 22 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<rect
				width='22'
				height='16'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2255_75725'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='22'
				height='16'
			>
				<rect
					width='22'
					height='16'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2255_75725)'>
				<path
					d='M22 16H0V14.9336H22V16ZM22 13.8662H0V12.7998H22V13.8662ZM22 11.7334H0V10.667H22V11.7334ZM22 9.59961H0V8.5332H22V9.59961ZM22 7.4668H0V6.40039H22V7.4668ZM22 5.33301H0V4.2666H22V5.33301ZM22 3.2002H0V2.13379H22V3.2002ZM22 1.06641H0V0H22V1.06641Z'
					fill='#D02F44'
				/>
				<rect
					width='9.42857'
					height='7.46667'
					fill='#46467F'
				/>
				<g filter='url(#filter0_d_2255_75725)'>
					<path
						d='M1.57104 5.33325C1.86027 5.33325 2.09536 5.57199 2.09546 5.86646C2.09546 6.16101 1.86034 6.39966 1.57104 6.39966C1.28192 6.39945 1.04761 6.16088 1.04761 5.86646C1.04771 5.57212 1.28199 5.33346 1.57104 5.33325ZM3.66675 5.33325C3.95593 5.3333 4.19008 5.57202 4.19019 5.86646C4.19019 6.16098 3.956 6.39961 3.66675 6.39966C3.37746 6.39966 3.14331 6.16101 3.14331 5.86646C3.14341 5.57199 3.37752 5.33325 3.66675 5.33325ZM5.76147 5.33325C6.0507 5.33325 6.28578 5.57199 6.28589 5.86646C6.28589 6.16101 6.05077 6.39966 5.76147 6.39966C5.47238 6.39943 5.23804 6.16086 5.23804 5.86646C5.23814 5.57214 5.47244 5.33348 5.76147 5.33325ZM7.85718 5.33325C8.14638 5.33328 8.38051 5.57201 8.38062 5.86646C8.38062 6.16099 8.14645 6.39963 7.85718 6.39966C7.56789 6.39966 7.33374 6.16101 7.33374 5.86646C7.33384 5.57199 7.56795 5.33325 7.85718 5.33325ZM2.6189 4.26685C2.90819 4.26685 3.14331 4.5055 3.14331 4.80005C3.14328 5.09457 2.90817 5.33325 2.6189 5.33325C2.32969 5.33318 2.09549 5.09452 2.09546 4.80005C2.09546 4.50554 2.32967 4.26692 2.6189 4.26685ZM4.7146 4.26685C5.00374 4.26702 5.23804 4.50561 5.23804 4.80005C5.238 5.09446 5.00372 5.33307 4.7146 5.33325C4.42533 5.33325 4.19022 5.09457 4.19019 4.80005C4.19019 4.5055 4.42531 4.26685 4.7146 4.26685ZM6.80933 4.26685C7.09862 4.26685 7.33374 4.5055 7.33374 4.80005C7.33371 5.09457 7.0986 5.33325 6.80933 5.33325C6.52014 5.33315 6.28592 5.09451 6.28589 4.80005C6.28589 4.50556 6.52012 4.26695 6.80933 4.26685ZM1.57104 3.20044C1.86034 3.20044 2.09546 3.43909 2.09546 3.73364C2.09529 4.02804 1.86023 4.26685 1.57104 4.26685C1.28203 4.26664 1.04778 4.02792 1.04761 3.73364C1.04761 3.43922 1.28192 3.20064 1.57104 3.20044ZM3.66675 3.20044C3.956 3.20049 4.19019 3.43912 4.19019 3.73364C4.19001 4.02801 3.95589 4.26679 3.66675 4.26685C3.37756 4.26685 3.14348 4.02804 3.14331 3.73364C3.14331 3.43909 3.37746 3.20044 3.66675 3.20044ZM5.76147 3.20044C6.05077 3.20044 6.28589 3.43909 6.28589 3.73364C6.28572 4.02804 6.05066 4.26685 5.76147 4.26685C5.47248 4.26662 5.23821 4.0279 5.23804 3.73364C5.23804 3.43923 5.47238 3.20067 5.76147 3.20044ZM7.85718 3.20044C8.14645 3.20046 8.38062 3.43911 8.38062 3.73364C8.38044 4.02803 8.14634 4.26682 7.85718 4.26685C7.56799 4.26685 7.33391 4.02804 7.33374 3.73364C7.33374 3.43909 7.56789 3.20044 7.85718 3.20044ZM2.6189 2.13306C2.90806 2.13306 3.1431 2.37189 3.14331 2.66626C3.14331 2.96081 2.90819 3.20044 2.6189 3.20044C2.32967 3.20036 2.09546 2.96076 2.09546 2.66626C2.09567 2.37193 2.3298 2.13313 2.6189 2.13306ZM4.7146 2.13306C5.00361 2.13324 5.23783 2.372 5.23804 2.66626C5.23804 2.9607 5.00374 3.20026 4.7146 3.20044C4.42531 3.20044 4.19019 2.96081 4.19019 2.66626C4.19039 2.37189 4.42544 2.13306 4.7146 2.13306ZM6.80933 2.13306C7.09849 2.13306 7.33353 2.37189 7.33374 2.66626C7.33374 2.96081 7.09862 3.20044 6.80933 3.20044C6.52012 3.20034 6.28589 2.96075 6.28589 2.66626C6.2861 2.37195 6.52025 2.13316 6.80933 2.13306ZM1.57104 1.06665C1.86029 1.06665 2.09539 1.30536 2.09546 1.59985C2.09546 1.89441 1.86034 2.13306 1.57104 2.13306C1.28192 2.13285 1.04761 1.89428 1.04761 1.59985C1.04768 1.30549 1.28197 1.06685 1.57104 1.06665ZM3.66675 1.06665C3.95595 1.0667 4.19012 1.30539 4.19019 1.59985C4.19019 1.89437 3.956 2.13301 3.66675 2.13306C3.37746 2.13306 3.14331 1.89441 3.14331 1.59985C3.14338 1.30536 3.3775 1.06665 3.66675 1.06665ZM5.76147 1.06665C6.05072 1.06665 6.28582 1.30536 6.28589 1.59985C6.28589 1.89441 6.05077 2.13306 5.76147 2.13306C5.47238 2.13283 5.23804 1.89426 5.23804 1.59985C5.23811 1.3055 5.47242 1.06688 5.76147 1.06665ZM7.85718 1.06665C8.14641 1.06668 8.38055 1.30538 8.38062 1.59985C8.38062 1.89439 8.14645 2.13303 7.85718 2.13306C7.56789 2.13306 7.33374 1.89441 7.33374 1.59985C7.33381 1.30536 7.56793 1.06665 7.85718 1.06665Z'
						fill='url(#paint0_linear_2255_75725)'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_d_2255_75725'
					x='1.04761'
					y='1.06665'
					width='7.33301'
					height='6.33301'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2255_75725'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2255_75725'
						result='shape'
					/>
				</filter>
				<linearGradient
					id='paint0_linear_2255_75725'
					x1='1.04761'
					y1='1.06665'
					x2='1.04761'
					y2='6.39966'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='white' />
					<stop
						offset='1'
						stopColor='#F0F0F0'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};
